import { normalizeAssistantStatus } from "@/store/assistant/assistant-status";
import { AssistantTaskStatus } from "@/store/assistant/types";

const CLOSED_ASSISTANT_TASK_STATUS_VALUES = new Set<string>([
  AssistantTaskStatus.Completed,
  AssistantTaskStatus.Canceled,
]);

export const normalizeAssistantTaskStatus = ({ status }: { status: string }) =>
  normalizeAssistantStatus({ status });

export const isClosedAssistantTaskStatus = ({ status }: { status: string }) =>
  CLOSED_ASSISTANT_TASK_STATUS_VALUES.has(normalizeAssistantTaskStatus({ status }));
